export default __webpack_public_path__ + "static/media/option-quantity.1ef9434d.png";